<script setup>
import { onMounted, defineProps } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "标题一",
  },
  subtitle: {
    type: String,
    default: "副标题",
  },
});

onMounted(() => {});
</script>

<template>
  <div data-aos="fade-up" class="section_title">
    <div class="section_top">
      {{ title }}
    </div>
    <div class="section_bottom">
      {{ subtitle }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.section_title {
  padding: 40px 0;

  .section_top {
    font-weight: bold;
    font-size: 40px;
    color: #000;
  }

  .section_bottom {
    font-size: 18px;
    color: #333333;
  }
}
@media (max-width: 768px) {
  .section_title {
    padding: 20px 0;
  }
  .section_top {
    font-size: 24px !important;
  }

  .section_bottom {
    font-size: 20px !important;
  }
}
</style>
